export default "__VITE_ASSET__C$wl7UDI__"